export enum TipoMotivoInadimplencia {
    PROBLEMAS_FINANCEIROS = "PROBLEMAS_FINANCEIROS",
    NAO_CONCORDA_COBRANCA  = "NAO_CONCORDA_COBRANCA",
    NAO_RECEBEU_BOLETO = "NAO_RECEBEU_BOLETO",
    SEM_CONTATO = "SEM_CONTATO",
}

export const getMotivoInadimplenciaFormatado = (motivoInadimplencia : TipoMotivoInadimplencia) => {
    switch(motivoInadimplencia){
        case TipoMotivoInadimplencia.PROBLEMAS_FINANCEIROS:
            return 'Problemas financeiros'
        case TipoMotivoInadimplencia.NAO_CONCORDA_COBRANCA:
            return 'Não concorda com a cobrança'
        case TipoMotivoInadimplencia.NAO_RECEBEU_BOLETO:
            return 'Não recebeu boleto'
        case TipoMotivoInadimplencia.SEM_CONTATO:
            return 'Sem contato'

    }

}
